import React from "react";
import GoBackArrow from "../Assets/Images/go-back-arrow.svg";

export default function GoBack({action = () => 0}) {
	return (
		<button className='go-back' onClick={action}>
			<img src={GoBackArrow} alt='Botón de regresar'></img>
			<p>Regresar</p>
		</button>
	);
}
